import { createSlice } from "@reduxjs/toolkit";
import {
  AllReviewsThunk,
  GetSingleReviewThunk,
  AddReviewThunk,
  UpdateReviewThunk,
  DeleteReviewThunk,
  AllProdutListThunk,
  AllUserListThunk
} from "./thunk";

const initialState = {
  reviews: [],
  products: [],
  users: [],
  singleReview: null,
  loading: false,
  error: null,
  successMessage: null,
};

const reviewsSlice = createSlice({
  name: "reviews",
  initialState,
  reducers: {
    clearReviewState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* -------------------- ALL REVIEWS -------------------- */
      .addCase(AllReviewsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllReviewsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload?.data || [];
      })
      .addCase(AllReviewsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ALL PRODUCTS -------------------- */
      .addCase(AllProdutListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllProdutListThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload || [];
      })
      .addCase(AllProdutListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ALL PRODUCTS -------------------- */
      .addCase(AllUserListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllUserListThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload || [];
      })
      .addCase(AllUserListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- SINGLE REVIEW -------------------- */
      .addCase(GetSingleReviewThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleReviewThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleReview = action.payload?.data || null;
      })
      .addCase(GetSingleReviewThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ADD REVIEW -------------------- */
      .addCase(AddReviewThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddReviewThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Review added successfully!";
      })
      .addCase(AddReviewThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- UPDATE REVIEW -------------------- */
      .addCase(UpdateReviewThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateReviewThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Review updated successfully!";
      })
      .addCase(UpdateReviewThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- DELETE REVIEW -------------------- */
      .addCase(DeleteReviewThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteReviewThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = state.reviews.filter(
          (r) => r.uuid !== action.payload.uuid
        );
        state.successMessage =
          action.payload.message || "Review deleted successfully!";
      })
      .addCase(DeleteReviewThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearReviewState } = reviewsSlice.actions;
export default reviewsSlice.reducer;
